/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";

import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
// Formik and Yup

import { useFormik } from "formik";
import * as Yup from "yup";

import moment from "moment";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import TextError from "utils/TextError";
// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function
import { addMinutes, format } from "date-fns";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createCircular,
  deleteCircular,
  getCirculars,
  getSubModulesByRoleId,
  updateCircular,
} from "../../../store";

// config file
import Config from "../../../config/index";

// Cookies
import DateObject from "react-date-object";
import DatePicker from "react-datepicker";
import Cookies from "universal-cookie";

import { Backdrop, CircularProgress } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import "react-datepicker/dist/react-datepicker.css";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 500 },
  overflow: "auto",
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForLabelModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const CircularPrevious = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getCirculars,
  getCircularsReducer,
  createCircular,
  updateCircular,
  deleteCircular,
}) => {
  let user = cookies.get("loginDetailsForWMS");
  // let role = user.data.data.role;
  let roleName = user.data.roleName;
  let roleId = user.data.roleId;
  let userId = user.data.userId;
  let jwtToken = user?.jwt;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let circularModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "7a6d46c8-90a9-423c-89c7-67e251c6ecba",
  );

  let createAccess = circularModule
    ? circularModule.actionId.includes("d6df89a2-3875-45ed-a6cb-35ea7c410e86")
    : null;

  let updateAccess = circularModule
    ? circularModule.actionId.includes("ae7a2453-4298-48c4-9ed7-e002d0d48064")
    : null;

  let deleteAccess = circularModule
    ? circularModule.actionId.includes("4f710a39-9fb2-44e9-adaf-94ddc53228d5")
    : null;

  let viewAccess = circularModule
    ? circularModule.actionId.includes("82afb464-2a65-42d1-8125-be21c1952737")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    getCirculars(0, pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "Circular Title", accessor: "title", align: "left" },
      {
        Header: "Circular Description ",
        accessor: "description",
        align: "left",
      },
      {
        Header: "Start Date",
        accessor: "startDate",
        searchType: "date",
        Cell: ({ value }) => {
          return format(
            addMinutes(new Date(value), new Date(value)?.getTimezoneOffset()),
            "dd-MM-yyyy, HH:mm",
          );
        },
      },
      {
        Header: "Expire Date",
        accessor: "expiryDate",
        searchType: "date",
        Cell: ({ value }) => {
          return format(
            addMinutes(new Date(value), new Date(value)?.getTimezoneOffset()),
            "dd-MM-yyyy, HH:mm",
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [datetime24h, setDateTime24h] = useState(new Date());

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let tempCircular = [];
    let data = getCircularsReducer.circulars.data
      ? getCircularsReducer.circulars.data
      : [];

    setLoading(getCircularsReducer.loading);
    setPaginationObj(getCircularsReducer.circulars.pagination);

    data.map((circular) => {
      const circularObject = {
        title: circular.title,
        description: circular.description,
        startDate: circular.startDate,
        expiryDate: circular.expiryDate,
        action: (
          <div>
            <EditButton
              tooltip="Edit Circular"
              disabled={!updateAccess}
              variant="gradient"
              color="success"
              iconOnly
              type="button"
              onClick={() => handleOpenUpdateCircularModal(circular)}
              style={{ marginRight: "5px" }}
            >
              <Icon>edit_sharp</Icon>
            </EditButton>

            <DeleteButton
              tooltip="Delete Circular"
              disabled={!deleteAccess}
              variant="gradient"
              color="error"
              iconOnly
              type="button"
              onClick={() => handleOpenDeleteCircularModal(circular)}
            >
              <Icon>delete</Icon>
            </DeleteButton>
          </div>
        ),
      };
      tempCircular.push(circularObject);
    });

    viewAccess && setState({ ...state, rows: tempCircular });
  }, [getCircularsReducer]);

  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setCreateCircularModal(!createCircularModal);

    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  let today =
    new Date().getDate() +
    "/" +
    (new Date().getMonth() + 1) +
    "/" +
    new Date().getFullYear();

  const initialValues = {
    title: "",
    description: "",
    expiryDate: "",
    startDate: new Date().toISOString(),
  };
  const validationSchema = Yup.object({
    title: Yup.string().required("Enter a title"),
    description: Yup.string().required("Enter a description"),
    // expiry: Yup.date().required("Select a expiry date"),
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
    }
  }, [isSuccess]);

  const [errorMsg, setErrorMsg] = useState("");
  const onSubmit = async (values) => {
    let payload = {
      title: values.title,
      description: values.description,
      startDate: startDateForPayloadCreate,

      expiryDate: expiryDateForPayloadCreate,
    };

    let res = await createCircular(payload, jwtToken);

    if (res.status) {
      getCirculars(0, pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccess(true);
    }
    if (!res.status) {
      setErrorMsg(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg,
      );
      setIsError(true);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [startDate, setStartDate] = useState(new Date());

  const handleStartDateChange = (data) => {
    setStartDate(data);
    setExpiryDate(new Date(endDate));
  };

  let endDate = moment(new Date(startDate)).add(24, "hours");

  const [expiryDate, setExpiryDate] = useState(new Date(endDate));

  var startDateForPayload = new DateObject(startDate);

  var expiryDateForPayload = new DateObject(expiryDate);

  let startDateForPayloadCreate = startDateForPayload.format(
    "YYYY/MM/DD HH:mm:ss",
  );

  let expiryDateForPayloadCreate = expiryDateForPayload.format(
    "YYYY/MM/DD HH:mm:ss",
  );

  const [openDeleteCircularModal, setOpenDeleteCircularModal] = useState(false);
  const [singleCircularDataForDelete, setCircularDataForDelete] = useState({});
  const handleOpenDeleteCircularModal = (circular = {}) => {
    setCircularDataForDelete(circular);
    setOpenDeleteCircularModal(true);
  };
  const handleCloseDeleteCircularModal = () => {
    setOpenDeleteCircularModal(false);
  };

  const [openUpdateCircularModal, setOpenUpdateCircularModal] = useState(false);
  const [singleCircularDataForUpdate, setCircularDataForUpdate] = useState({});

  let s = singleCircularDataForUpdate?.startDate;

  const [startDateForUpdate, setStartDateForUpdate] = useState(null);

  const [expiryDateForUpdate, setExpiryDateForUpdate] = useState(null);

  var startDateForPayload2 = new DateObject(startDateForUpdate);

  var expiryDateForPayload2 = new DateObject(expiryDateForUpdate);

  let startDateForPayloadUpdate = startDateForPayload2.format(
    "YYYY/MM/DD HH:mm:ss",
  );

  let expiryDateForPayloadUpdate = expiryDateForPayload2.format(
    "YYYY/MM/DD HH:mm:ss",
  );

  const handleOpenUpdateCircularModal = (circular = {}) => {
    // let expiryDateForUpdate = new DateObject(circular?.expiryDate);
    // expiryDateForUpdate2 = expiryDateForUpdate.format("yyyy-MM-dd");
    setCircularDataForUpdate(circular);
    setStartDateForUpdate(
      new Date(
        new Date(circular?.startDate).getTime() +
          new Date(circular?.startDate).getTimezoneOffset() * 60000,
      ),
    );

    setExpiryDateForUpdate(
      new Date(
        new Date(circular?.expiryDate).getTime() +
          new Date(circular?.expiryDate).getTimezoneOffset() * 60000,
      ),
    );
    setOpenUpdateCircularModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateCircularModal = () => {
    setOpenUpdateCircularModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    circularId: singleCircularDataForUpdate.id,
    title: singleCircularDataForUpdate.title,
    description: singleCircularDataForUpdate.description,
    startDate: singleCircularDataForUpdate?.startDate,
    expiryDate: singleCircularDataForUpdate?.expiryDate,
  };

  const validationSchemaForUpdate = Yup.object({
    title: Yup.string().required("Enter the circular title!"),
    description: Yup.string().required("Enter a description"),
  });

  const [updateErrorMsg, setUpdateErrorMsg] = useState("");

  const onSubmitForUpdate = async (values) => {
    let payload = {
      id: singleCircularDataForUpdate.id,
      title: values.title,
      description: values.description,
      startDate: startDateForPayloadUpdate,
      expiryDate: expiryDateForPayloadUpdate,
    };

    let res = await updateCircular(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getCirculars(0, pageNo, rowsPerPage, searchObject, jwtToken);
    }
    if (!res.status) {
      setUpdateErrorMsg(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg,
      );
      setIsErrorForUpdate(true);
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  let endDateForUpdate = moment(formikForUpdate.values.startDate)
    .add(1, "days")

    .format("YYYY-MM-DD");

  const [isErrorDeleteCircular, setIsErrorDeleteCircular] = useState(false);
  const [isSuccessDeleteCircular, setIsSuccessDeleteCircular] = useState(false);

  useEffect(() => {
    if (isErrorDeleteCircular) {
      setTimeout(() => {
        setIsErrorDeleteCircular(false);
      }, 3000);
    }
  }, [isErrorDeleteCircular]);

  useEffect(() => {
    if (isSuccessDeleteCircular) {
      setTimeout(() => {
        setIsSuccessDeleteCircular(false);
      }, 3000);
    }
  }, [isSuccessDeleteCircular]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteCircularData = async () => {
    let circularId = singleCircularDataForDelete.id;

    let response = await deleteCircular(circularId, jwtToken);
    if (response.status) {
      getCirculars(0, pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseDeleteCircularModal();
      }, 4000);

      setIsSuccessDeleteCircular(true);
    }
    if (!response.status) {
      setDeleteErrorMsg(
        response.data.data.message
          ? response.data.data.message
          : response?.data?.data?.msg,
      );
      setIsErrorDeleteCircular(true);
    }
  };

  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-3}
              >
                <MDBox mt={2}>
                  <CreateButton
                    tooltip="Add Circular"
                    disabled={!createAccess}
                    color="info"
                    variant="contained"
                    type="button"
                    style={{ marginRight: "10px" }}
                    onClick={handleCreateCircularModal}
                  >
                    Add Circular
                  </CreateButton>
                </MDBox>

                <MDBox color="text" px={2} mt={4} display="flex">
                  {/* <MDBox mr={2}>
                    {uploadCsvFilter && (
                      <div>
                        <div>
                          <input
                            className="choose_file"
                            style={
                              {
                                // marginTop: "1.5rem",
                                // marginLeft: "0rem",
                                // marginBottom: "-9rem",
                              }
                            }
                            type="file"
                            accept=".csv"
                            onChange={(e) => {
                              setUploadCsvData(e.target.files[0]);
                            }}
                          />
                          <MDButton
                            disabled={
                              !uploadCsvData?.name ||
                              uploadCsvData?.type !== "text/csv"
                            }
                            variant="contained"
                            color="info"
                            style={{
                              marginLeft: "0",
                              marginTop: "0.3rem",
                              padding: 1,
                              height: "10px",
                            }}
                            type="button"
                            onClick={uploadCsvHandler}
                          >
                            Upload
                          </MDButton>
                        </div>
                        <div>
                          <span
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginLeft: "0px",
                              fontStyle: "italic",
                            }}
                          >
                            <strong>*</strong> Please upload
                            <strong>".csv"</strong> file only
                          </span>
                        </div>
                      </div>
                    )}
                  </MDBox>
                  <MDBox
                    display="flex"
                    marginRight={"50px"}
                    marginTop={!uploadCsvFilter ? "-8px" : "5px"}
                  >
                    <CSVLink {...csvLink2}>
                      <Tooltip title="Download Template">
                        <MDButton
                          style={{ marginRight: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="error"
                          iconOnly
                          title="Download Template"
                        >
                          <Icon>download</Icon>
                        </MDButton>
                      </Tooltip>
                    </CSVLink>

                    <CSVLink {...csvLink}>
                      <Tooltip title="Download All Data">
                        <MDButton
                          style={{ marginRight: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="success"
                          iconOnly
                          title="Download All Data"
                        >
                          <Icon>download</Icon>
                        </MDButton>
                      </Tooltip>
                    </CSVLink>

                    {uploadAccess && (
                      <Tooltip title="Upload CSV">
                        <MDButton
                          type="button"
                          variant="outlined"
                          color="info"
                          iconOnly
                          onClick={uploadCsvFilterHandler}
                          title="Upload CSV"
                        >
                          <Icon>upload</Icon>
                        </MDButton>
                      </Tooltip>
                    )}
                  </MDBox> */}
                </MDBox>
              </MDBox>

              <MDBox pt={1}>
                {/* {!loading ? ( */}
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                />

                {/* ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <CircularProgress color="info" />
                  </div>
                )} */}
              </MDBox>
              <Modal
                open={createCircularModal}
                onClose={handleCreateCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Circular
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Circular Title</MDTypography>

                        <MDInput
                          type="text"
                          name="title"
                          fullWidth
                          autoComplete="off"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.title}
                          error={
                            formik.touched.title && formik.errors.title && true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                            maxLength: 45,
                          }}
                        />

                        {formik.touched.title && formik.errors.title && (
                          <TextError msg={formik.errors.title} />
                        )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography variant="h6">
                          Circular Description
                        </MDTypography>

                        <MDInput
                          multiline
                          rows={2}
                          type="text"
                          name="description"
                          fullWidth
                          autoComplete="off"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.description}
                          error={
                            formik.touched.description &&
                            formik.errors.description &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "40px",
                            },
                            maxLength: 300,
                          }}
                        />

                        {formik.touched.description &&
                          formik.errors.description && (
                            <TextError msg={formik.errors.description} />
                          )}
                      </MDBox>

                      <MDBox
                        mb={2}
                        display="flex"
                        flexDirection={{
                          xs: "column",
                          lg: "row",
                        }}
                      >
                        <MDBox mr={2}>
                          <MDTypography variant="h6">Start Date</MDTypography>

                          <DatePicker
                            className="form-control"
                            selected={startDate}
                            onChange={handleStartDateChange}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                        </MDBox>

                        <MDBox>
                          <MDTypography variant="h6">Expiry Date</MDTypography>
                          <DatePicker
                            className="form-control"
                            selected={expiryDate}
                            onChange={(date) => setExpiryDate(date)}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {/* {formik.touched.expiryDate &&
                            formik.errors.expiryDate && (
                              <TextError msg={formik.errors.expiryDate} />
                            )} */}
                        </MDBox>
                      </MDBox>
                      <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openUpdateCircularModal}
                onClose={handleCloseUpdateCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update Circular
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Circular Title</MDTypography>

                        <MDInput
                          type="text"
                          name="title"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.title}
                          error={
                            formikForUpdate.touched.title &&
                            formikForUpdate.errors.title &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                            maxLength: 45,
                          }}
                        />

                        {formikForUpdate.touched.title &&
                          formikForUpdate.errors.title && (
                            <TextError msg={formikForUpdate.errors.title} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography variant="h6">
                          Circular Description
                        </MDTypography>

                        <MDInput
                          multiline
                          rows={2}
                          type="text"
                          name="description"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.description}
                          error={
                            formikForUpdate.touched.description &&
                            formikForUpdate.errors.description &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "40px",
                            },
                            maxLength: 300,
                          }}
                        />

                        {formikForUpdate.touched.description &&
                          formikForUpdate.errors.description && (
                            <TextError
                              msg={formikForUpdate.errors.description}
                            />
                          )}
                      </MDBox>
                      <MDBox
                        mb={2}
                        display="flex"
                        flexDirection={{
                          xs: "column",
                          lg: "row",
                        }}
                      >
                        <MDBox mb={2} mr={2}>
                          <MDTypography variant="h6">Start Date</MDTypography>

                          <DatePicker
                            className="form-control"
                            selected={startDateForUpdate}
                            onChange={(date) => setStartDateForUpdate(date)}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {formikForUpdate.touched.startDate &&
                            formikForUpdate.errors.startDate && (
                              <TextError
                                msg={formikForUpdate.errors.startDate}
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Expiry Date</MDTypography>

                          <DatePicker
                            className="form-control"
                            // style={{ width: "400px" }}
                            selected={expiryDateForUpdate}
                            onChange={(date) => setExpiryDateForUpdate(date)}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {formikForUpdate.touched.expiryDate &&
                            formikForUpdate.errors.expiryDate && (
                              <TextError
                                msg={formikForUpdate.errors.expiryDate}
                              />
                            )}
                        </MDBox>
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {updateErrorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formikForUpdate.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openDeleteCircularModal}
                onClose={handleCloseDeleteCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseDeleteCircularModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ float: "right" }}>
                      <MDButton
                        style={{ width: "100%", marginLeft: "0.5rem" }}
                        color="error"
                        onClick={deleteCircularData}
                      >
                        Delete
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteCircular}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteCircular(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {deleteErrorMsg}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessDeleteCircular}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessDeleteCircular(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Circular deleted successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getCircularsReducer: state.getCircularsReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getCirculars: (status, pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getCirculars(status, pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    createCircular: (payload, jwtToken) =>
      dispatch(createCircular(payload, jwtToken)),
    updateCircular: (payload, jwtToken) =>
      dispatch(updateCircular(payload, jwtToken)),
    deleteCircular: (circularId, jwtToken) =>
      dispatch(deleteCircular(circularId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(CircularPrevious);
